import { WiziQuizList } from './WiziQuizList';
import { WiziQuizCreate } from './WiziQuizCreate';
import { WiziQuizEdit } from './WiziQuizEdit';

export default {
    list: WiziQuizList,
    create: WiziQuizCreate,
    edit: WiziQuizEdit,
};
